module.exports = __webpack_public_path__ + "img/status_badge_bullet_complete.84e33478.svg";